const getApiBaseUrl = () =>
  String(
    process.env.REACT_APP_POS_API_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      "",
  ).replace(/\/+$/, "");

const parseResponseBody = async (response) => {
  try {
    const responseText = await response.text();
    return responseText ? JSON.parse(responseText) : null;
  } catch (error) {
    return null;
  }
};

export class TaxInvoiceReconciliationApiError extends Error {
  constructor(message, { status, data } = {}) {
    super(message);
    this.name = "TaxInvoiceReconciliationApiError";
    this.status = status;
    this.data = data;
    this.currentStatus =
      data?.currentStatus ||
      data?.data?.currentStatus ||
      data?.data?.Status ||
      null;
  }
}

const buildApiUrl = (path, query = {}) => {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) {
    throw new TaxInvoiceReconciliationApiError(
      "Chưa cấu hình POS Backend API URL.",
    );
  }

  const searchParams = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return `${apiBaseUrl}${path}${queryString ? `?${queryString}` : ""}`;
};

export const requestTaxInvoiceApi = async (path, { method = "GET", query, body } = {}) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new TaxInvoiceReconciliationApiError(
      "Phiên đăng nhập đã hết hạn.",
      { status: 401 },
    );
  }

  const response = await fetch(buildApiUrl(path, query), {
    method,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const responseData = await parseResponseBody(response);

  if (!response.ok || responseData?.success === false) {
    throw new TaxInvoiceReconciliationApiError(
      responseData?.message ||
        responseData?.error ||
        `Không thể xử lý yêu cầu (HTTP ${response.status}).`,
      { status: response.status, data: responseData },
    );
  }

  return responseData;
};

export const fetchTaxInvoiceReconciliations = ({
  status = "UNKNOWN",
  MaCH = "",
  fromDate = "",
  toDate = "",
  page = 1,
  pageSize = 50,
} = {}) =>
  requestTaxInvoiceApi("/api/tax-invoice-reconciliation", {
    query: { status, MaCH, fromDate, toDate, page, pageSize },
  });

export const fetchTaxInvoiceReconciliationDetail = (IDXuat) =>
  requestTaxInvoiceApi(
    `/api/tax-invoice-reconciliation/${encodeURIComponent(String(IDXuat))}`,
  );

export const resolveTaxInvoiceReconciliation = (IDXuat, payload) =>
  requestTaxInvoiceApi(
    `/api/tax-invoice-reconciliation/${encodeURIComponent(
      String(IDXuat),
    )}/resolve`,
    {
      method: "POST",
      body: payload,
    },
  );
